

const TYPES = [
  {
    type: 'graph',
    icon: 'dataflow-02',
    title: 'Genrate Graph'
  },
  {
    type: 'api',
    icon: 'code-browser',
    title: 'API'
  },
  {
    type: 'internal',
    icon: 'alert-circle',
    title: 'Internal'
  },
  {
    type: 'file',
    icon: 'file-text',
    title: 'Document'
  }
]

const __default__ = {
  props: {
    type: {type: String, required: true},
    internal: {type: Boolean, default: false},
    showTitle: {type: Boolean, default: true}
  },
  computed: {
    type_obj() {
      if (this.internal) return TYPES.find(t => t.type === 'internal')
      return TYPES.find(t => t.type === this.type)
    },
    icon(){
      return this.type_obj.icon
    },
    title() {
      return this.type_obj.title
    },
    color(){
      if (this.internal) return 'var(--error-700)'
      return 'var(--gray-500)'
    }
  }
}

import { useCssVars as _useCssVars } from 'vue'
const __injectCSSVars__ = () => {
_useCssVars(_ctx => ({
  "39e2605e-color": (_ctx.color)
}))}
const __setup__ = __default__.setup
__default__.setup = __setup__
  ? (props, ctx) => { __injectCSSVars__();return __setup__(props, ctx) }
  : __injectCSSVars__

export default __default__